<template>
  <v-layout
    column
    data-cy="menu-pages-navbar"
  >
    <!-- Navbar -->
    <v-layout
      align-center
      wrap
      :class="{
        'mb-2': $vuetify.breakpoint.xs,
      }"
    >
      <!-- Menu Items -->
      <v-btn
        flat
        :small="$vuetify.breakpoint.xs"
        class="menu-pages-navbar-btn mx-0"
        :color="$route.name == 'menuitems' ? 'black' : 'grey'"
        :to="{name: 'menuitems', params: {menuId: currentMenuId}}"
      >
        {{ $t('menuitems') }}
      </v-btn>
      <!-- Menu Categories -->
      <v-btn
        flat
        :small="$vuetify.breakpoint.xs"
        class="menu-pages-navbar-btn mx-0"
        :color="$route.name == 'menucategories' ? 'black' : 'grey'"
        :to="{name: 'menucategories', params: {menuId: currentMenuId}}"
        :title="$t('menuCategoriesSubheader')"
      >
        {{ $t('menucategories') }}
      </v-btn>
      <!-- Menu Additives -->
      <v-btn
        flat
        :small="$vuetify.breakpoint.xs"
        class="menu-pages-navbar-btn mx-0"
        :color="$route.name == 'menuadditives' ? 'black' : 'grey'"
        :to="{name: 'menuadditives', params: {menuId: currentMenuId}}"
        :title="$t('menuAdditivesSubheader')"
      >
        {{ $t('menuadditives') }}
      </v-btn>
      <!-- Assignment of Categories to Decoders (StoreMenu / MenuCategoryDecoders) -->
      <v-btn
        flat
        :small="$vuetify.breakpoint.xs"
        class="menu-pages-navbar-btn mx-0"
        :color="
          ['menucategorydecoders', 'storemenu'].includes($route.name)
            ? 'black'
            : 'grey'
        "
        :to="menuCategoryDecodersAssignmentRoute"
        :title="$t('menuCategoryDecodersPageHint')"
      >
        {{ $t('menucategorydecoders') }}
      </v-btn>
      <!-- QR-Code -->
      <v-btn
        flat
        :small="$vuetify.breakpoint.xs"
        class="menu-pages-navbar-btn mx-0"
        :color="$route.name == 'menuqrcode' ? 'black' : 'grey'"
        :to="{name: 'menuqrcode', params: {menuId: currentMenuId}}"
        :title="$t('menuqrcode')"
      >
        {{ $t('menuqrcode') }}
      </v-btn>
      <!-- Start -->
      <v-btn
        flat
        :small="$vuetify.breakpoint.xs"
        class="menu-pages-navbar-btn mx-0"
        :color="$route.name == 'menustart' ? 'black' : 'grey'"
        :to="{name: 'menustart', params: {menuId: currentMenuId}}"
        :title="$t('menustart')"
      >
        <v-icon medium>
          help_outline
        </v-icon>
      </v-btn>
      <slot name="extra" />
    </v-layout>
    <!-- Demo Hint -->
    <v-layout
      v-if="hasDemoMenu && $route.name !== 'menustart'"
      align-center
      class="mt-2"
    >
      <v-chip
        :title="$t('isDemoMenu')"
        small
        class="ml-0 my-0 grey--text text--darken-2"
        style="max-height: 20px"
      >
        Demo
      </v-chip>
      <div
        v-if="$vuetify.breakpoint.smAndUp"
        class="caption grey--text text--darken-1 ml-1"
      >
        {{ $t('isDemoMenuResetHint') }}.
      </div>
    </v-layout>
  </v-layout>
</template>

<script>
/**
 * Route to last Store with Menu visited or first one available.
 *
 * If no Stores exist, route to the list page for assignments.
 */
export function getMenuCategoryDecodersAssignmentRoute(
  lastStoreWithMenuVisited,
  storesWithTVDecodersForMenuCategories
) {
  if (lastStoreWithMenuVisited) {
    return {
      name: 'storemenu',
      params: {storeId: lastStoreWithMenuVisited.id},
    };
  }

  if (storesWithTVDecodersForMenuCategories.length === 0) {
    return {name: 'menucategorydecoders'};
  }

  return {
    name: 'storemenu',
    params: {storeId: storesWithTVDecodersForMenuCategories[0].id},
  };
}

export default {
  props: {
    /**
     * Menu ID to use for link status.
     *
     * If not specified, we'll try to pull it from the route instead,
     * which will work for most routes and simplifies configuration per
     * page.
     */
    menuId: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    menuCategoryDecodersAssignmentRoute() {
      return getMenuCategoryDecodersAssignmentRoute(
        this.$store.state.common.lastStoreWithMenuVisited,
        this.$store.state.common.storesWithTVDecodersForMenuCategories
      );
    },
    /**
     * Use passed menuId if it exists, otherwise try to pull it from the route.
     */
    currentMenuId() {
      return this.menuId || this.$route.params.menuId || this.$route.query.menu;
    },
    layout() {
      if (this.$vuetify.breakpoint.xs) {
        return {column: true};
      }
      return {row: true};
    },
    hasDemoMenu() {
      return (
        this.$store.state.common.menus.length === 1 &&
        this.$store.state.common.menus[0].is_demo
      );
    },
  },
  created() {
    // Only request this once when we have no data yet, as we assume it
    // won't change within the tab session.
    if (
      this.$store.state.common.storesWithTVDecodersForMenuCategories.length ===
      0
    ) {
      this.$store.dispatch(
        'LIST_STORES_WITH_TV_DECODERS_FOR_MENU_CATEGORIES',
        this.currentMenuId
      );
    }
  },
};
</script>

<style scoped>
.menu-pages-navbar-btn {
  text-transform: none;
  min-width: 0;
  font-size: 22px;
  font-weight: bold;
  line-height: 1;
  letter-spacing: 0.04em;
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu/MenuPagesNavbar.vue